(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aigo-facets"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.filters .fgroup__h').forEach(function(h) {
  h.addEventListener('click', function() {
    h.closest('.fgroup').classList.toggle('collapsed');
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aigo-mega-panel"] && !Shopify.designMode) return;
  try {
    /* Sidebar panel switcher — event-delegated, scoped to the clicked item's .mega container */
document.addEventListener('click', function (e) {
  var item = e.target.closest('.msb__item[data-panel]');
  if (!item) return;
  var mega = item.closest('.mega');
  if (!mega) return;
  mega.querySelectorAll('.msb__item').forEach(function (i) { i.classList.remove('is-active'); });
  item.classList.add('is-active');
  mega.querySelectorAll('.msb__panel').forEach(function (p) { p.hidden = true; });
  var target = mega.querySelector('#' + item.dataset.panel);
  if (target) target.hidden = false;
});
  } catch(e) { console.error(e); }
})();

})();
